// extracted by mini-css-extract-plugin
export default {"box-shadow-contsiner":"mainsection_box-shadow-contsiner__bxBq5","documnetpaymetrecipt":"mainsection_documnetpaymetrecipt__2GwC7"};